module.exports = __webpack_public_path__ + "img/instagram-icon.7204ec38.svg";